import { Phone, ArrowRight } from "lucide-react";
import { COMPANY } from "@/i18n";

export default function HeroActions({ ctaPrimary, ctaSecondary, scrollTo }) {
  return (
    <div className="mt-10 flex flex-wrap items-center gap-4">
      <button
        onClick={() => scrollTo("booking")}
        className="btn-primary"
        data-testid="hero-book-btn"
      >
        {ctaPrimary}
        <ArrowRight className="w-5 h-5" />
      </button>
      <a
        href={`tel:${COMPANY.phoneIntl}`}
        className="btn-secondary"
        data-testid="hero-call-btn"
      >
        <Phone className="w-5 h-5" />
        {ctaSecondary}
      </a>
    </div>
  );
}
